var effic_ing_products = {
  "advantage": {
    "name": "Noobru™ Advantage",
    "amount": null,
    "label": "Shop now",
    "href": "/products/noobru-advantage",
    "src": "https://noobru.com/cdn/shop/files/adv_berry_3_month_091e0365-7bd8-471e-b7e5-aeb08d6b0d7b.webp"
  },
  "shield": {
    "name": "Noobru™ Shield",
    "amount": null,
    "label": "Shop now",
    "href": "/products/noobru-shield",
    "src": "https://noobru.com/cdn/shop/files/shield_3_month.webp"
  },
  "lucid": {
    "name": "Noobru™ Lucid",
    "amount": null,
    "label": "Shop now",
    "href": "/products/noobru-lucid",
    "src": "https://noobru.com/cdn/shop/files/Lucid_3_month.webp"
  },
  "pro": {
    "name": "Noobru™ Pro",
    "amount": null,
    "label": "Shop now",
    "href": "/products/noobru-pro",
    "src": "https://noobru.com/cdn/shop/files/PRO_-_3_Months.webp"
  },
  "bta": {
    "name": "Noobru™ Better Than Ashwagandha",
    "amount": null,
    "label": "Shop now",
    "href": "/products/noobru-better-than-ashwagandha",
    "src": "https://noobru.com/cdn/shop/files/Ash_3_month.webp"
  },
  "btr": {
    "name": "Noobru™ Better Than Resveratrol",
    "amount": null,
    "label": "Shop now",
    "href": "/products/noobru-better-than-resveratrol-mango",
    "src": "https://noobru.com/cdn/shop/files/res-3-month.jpg"
  },
  "btg": {
    "name": "Noobru™ Better Than Glutathione",
    "amount": null,
    "label": "Shop now",
    "href": "/products/noobru-better-than-glutathione",
    "src": "https://noobru.com/cdn/shop/files/glu_3_month.webp"
  },
  "sprint": {
    "name": "Noobru™ Sprint - Energy 2.0",
    "amount": null,
    "label": "Shop now",
    "href": "/products/noobru-sprint",
    "src": "https://noobru.com/cdn/shop/files/3_month_sprint_e38cac82-ee7f-4df7-a527-8890992f8c35.webp"
  },
  "zeus": {
    "name": "Noobru™ Zeus",
    "amount": null,
    "label": "Shop now",
    "href": "/products/noobru-zeus",
    "src": "https://noobru.com/cdn/shop/files/zeus_2_month.webp"
  },
  "cheat": {
    "name": "Noobru™ Cheat",
    "amount": null,
    "label": "Shop now",
    "href": "/products/noobru-cheat",
    "src": "https://noobru.com/cdn/shop/files/cheat_3_month.webp"
  }
}
var effic_all_ingredients = [
  {
    "handle": "ingredient-5-htp",
    "name": "5-HTP",
    "img": "/ingredients_lucid/5-htp.jpeg",
    "img_desc": "/ingredient_description/5-htp.jpeg",
    "amounts": {
      "lucid": 50,
      "sprint": 20
    },
    "amount_in_products": [],
    "overview": "May support mood and mental health, improve sleep, aid weight loss, and reduce symptoms of fibromyalgia and migraines.",
    "derived_from": "The seeds of the African plant Griffonia simplicifolia.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 3106,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://www.cell.com/neuron/fulltext/S0896-6273(06)00457-0?_returnURL=https%3A%2F%2Flinkinghub.elsevier.com%2Fretrieve%2Fpii%2FS0896627306004570%3Fshowall%3Dtrue",
        "t": "May aid weight loss by increasing feelings of fullness"
      },
      {
        "l": "https://www.ncbi.nlm.nih.gov/books/NBK545168/",
        "t": "May help with depression by increasing serotonin levels"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/1521674/",
        "t": "Could improve symptoms of fibromyalgia"
      },
      {
        "l": "https://www.ncbi.nlm.nih.gov/books/NBK560787/",
        "t": "Could help reduce migraine frequency"
      },
      {
        "l": "https://www.ncbi.nlm.nih.gov/books/NBK534823/",
        "t": "May promote sleep by increasing melatonin production"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-acetyl-l-carnitine",
    "name": "Acetyl L Carnitine",
    "img": "/ingredients_pro/acetyl_l_carnitine.jpg",
    "img_desc": "/ingredient_description/acetyl_l_carnitine.jpg",
    "amounts": {
      "pro": 500
    },
    "amount_in_products": [],
    "overview": "Supports energy production, brain function, heart health, exercise performance, recovery, and blood sugar control in type 2 diabetes.",
    "derived_from": "An acetylated form of the amino acid L-carnitine.",
    "form": "",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 9057,
    "highlighted_research": [
      {
        "title": "Acetyl-L-Carnitine Supplementation and the Treatment of Depressive Symptoms: A Systematic Review and Meta-Analysis",
        "source": "National Library of Medicine"
      },
      {
        "title": "Acetyl-L-carnitine and alpha-lipoic acid: possible neurotherapeutic agents for mood disorders?",
        "source": "National Library of Medicine"
      },
      {
        "title": "Long-term acetyl-L-carnitine treatment in Alzheimer's disease",
        "source": "National Library of Medicine"
      },
      {
        "title": "Acetyl-L-carnitine as a precursor of acetylcholine",
        "source": "National Library of Medicine"
      }
    ],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/32359762/",
        "t": "L-carnitine helps move more fatty acids into your cells to be burned for energy"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7284336/",
        "t": "L-carnitine may benefit brain function"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31481697/",
        "t": "L-carnitine could benefit several aspects of heart health."
      },
      {
        "l": "http://pmc.ncbi.nlm.nih.gov/articles/PMC8704793/",
        "t": "L-carnitine may help improve: exercise and muscle recovery, muscle oxygen supply, exercise performance, endurance, and power"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9871499/",
        "t": "L-carnitine may be beneficial for people with type 2 diabetes."
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Energy & Exercise"
  },
  {
    "handle": "ingredient-alpha-lipoic-acid",
    "name": "Alpha Lipoic Acid",
    "img": "/ingredients/alpha-lipoic-acid.webp",
    "img_desc": "/ingredients/alpha-lipoic-acid.webp",
    "amounts": {
      "cheat": 220
    },
    "amount_in_products": [],
    "overview": "A powerful antioxidant that supports blood sugar control, nerve health, skin health, memory, and reduces inflammation and aging risk factors.",
    "derived_from": "A naturally occurring compound found in every cell of the human body, but also found in foods like spinach and broccoli.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 24195,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/18445126/",
        "t": "Though alpha-lipoic acid has properties that may promote weight loss, its overall effect in humans seems negligible"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29990473/",
        "t": "Alpha-lipoic acid has been shown to reduce insulin resistance, improve blood sugar control, ease symptoms of nerve damage, and lower the risk of diabetic retinopathy."
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/24056055/",
        "t": "May Reduce Skin Aging"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/24183945/",
        "t": "May slow memory loss"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/19499849/",
        "t": "Promotes healthy nerve function"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation"
  },
  {
    "handle": "ingredient-apple-cider-vinegar-powder",
    "name": "Apple Cider Vinegar Powder",
    "img": "/ingredients/apple-cider-vingar.webp",
    "img_desc": "/ingredients/apple-cider-vingar.webp",
    "amounts": {
      "cheat": 290
    },
    "amount_in_products": [],
    "overview": "High in acetic acid with antibacterial effects; may aid weight loss, heart health, skin health, and digestion.",
    "derived_from": "Fermented crushed apples.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 677,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7817673/",
        "t": "Can help kill harmful bacteria"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9193460/",
        "t": "May aid weight loss"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/32170375/",
        "t": "May improve heart health"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31328306/",
        "t": "May boost skin health"
      },
      {
        "l": "https://fdc.nal.usda.gov/food-details/173469/nutrients",
        "t": "High in acetic acid"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / General Wellness, Digestion & Skin"
  },
  {
    "handle": "ingredient-ashwagandha",
    "name": "Ashwagandha",
    "img": "/ingredients/ashwagandha.jpg",
    "img_desc": "/ingredient_description/ashwagandha.jpg",
    "amounts": {
      "advantage": 100,
      "lucid": 80,
      "pro": 100,
      "bta": 1000,
      "sprint": 200,
      "zeus": 100
    },
    "amount_in_products": [],
    "overview": "Reduces stress and anxiety, improves athletic performance, supports male fertility, lowers blood sugar, and benefits mental health.",
    "derived_from": "The roots and berries of the Withania somnifera plant.",
    "form": "KSM-66®",
    "found_in": [
      "Withania Somnifera"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 7987,
    "highlighted_research": [
      {
        "title": "Examining the effect of Withania somnifera supplementation on muscle strength and recovery: a randomized controlled trial",
        "source": "Journal of the International Society of Sports Nutrition"
      },
      {
        "title": "Effects of Withania somnifera (Ashwagandha) and Terminalia arjuna (Arjuna) on physical performance and cardiorespiratory endurance in healthy young adults",
        "source": "International Journal of Ayurveda Research"
      },
      {
        "title": "An investigation into the stress-relieving and pharmacological actions of an ashwagandha (Withania somnifera) extract: A randomized, double-blind, placebo-controlled study",
        "source": "Medicine (Baltimore)"
      },
      {
        "title": "A prospective, randomized double-blind, placebo-controlled study of safety and efficacy of a high-concentration full-spectrum extract of ashwagandha root in reducing stress and anxiety in adults",
        "source": "Indian Journal of Psychological Medicine"
      },
      {
        "title": "Examining the effect of Withania somnifera supplementation on muscle strength and recovery: a randomized controlled trial",
        "source": "Journal of the International Society of Sports Nutrition"
      }
    ],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6979308/",
        "t": "May help reduce stress and anxiety"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8006238/",
        "t": "May benefit athletic performance"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31046033/",
        "t": "May reduce symptoms of some mental health conditions"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6438434/",
        "t": "May help boost testosterone and increase fertility in men"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31975514/",
        "t": "May reduce blood sugar levels"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-astragalus-membranaceus-extract",
    "name": "Astragalus Root Extract",
    "img": "/ingredients_shield/astragalus_root_extract.png",
    "img_desc": "/ingredient_description/astragalus_root_extract.jpg",
    "amounts": {
      "shield": 10
    },
    "amount_in_products": [],
    "overview": "Strengthens the immune system, supports heart and kidney health, helps manage blood sugar, and reduces chemotherapy side effects.",
    "derived_from": "The roots of the Astragalus membranaceus plant.",
    "form": "Root Extract",
    "found_in": [
      "Astragalus membranaceus"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 546,
    "highlighted_research": [
      {
        "title": "Immune system effects of echinacea, ginseng, and astragalus: a review",
        "source": "Integrative Cancer Therapies"
      },
      {
        "title": "The Antioxidant Effects of Radix Astragali (Astragalus membranaceus and Related Species) in Protecting Tissues from Injury and Disease",
        "source": "Current Drug Targets"
      },
      {
        "title": "Immune Regulation of RAW264.7 Cells In Vitro by Flavonoids from Astragalus complanatus via Activating the NF- κ B Signalling Pathway",
        "source": "Journal of Immunology Research"
      },
      {
        "title": "Anti-Aging Implications of Astragalus Membranaceus (Huangqi): A Well-Known Chinese Tonic",
        "source": "Aging and Disease"
      }
    ],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/15035888/",
        "t": "May boost your immune system"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/20929124/",
        "t": "May improve heart function"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/12592686/",
        "t": "May alleviate side effects of chemotherapy"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/27269392/",
        "t": "May help control blood sugar levels"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10589061/",
        "t": "May improve kidney function"
      }
    ],
    "main_use_case": "Immunity & Inflammation"
  },
  {
    "handle": "ingredient-beetroot-extract-powder",
    "name": "Beetroot Extract Powder",
    "img": "/ingredients/beetroot.webp",
    "img_desc": "/ingredients/beetroot.webp",
    "amounts": {
      "advantage": 40,
      "shield": 15,
      "lucid": 250,
      "pro": 120,
      "bta": 60,
      "btr": 60,
      "btg": 40
    },
    "amount_in_products": [],
    "overview": "Promote healthy blood pressure, athletic performance, digestion, inflammation control, and brain health.",
    "derived_from": "The root of the Beta vulgaris plant.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 2409,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31553287/",
        "t": "Could help keep your blood pressure in check"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/28007968/",
        "t": "Can improve athletic performance"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/27278926/",
        "t": "May help fight inflammation"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7146107/",
        "t": "May improve digestive health"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4425174/",
        "t": "May support brain health"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Energy & Exercise"
  },
  {
    "handle": "ingredient-berberine",
    "name": "Berberine",
    "img": "/ingredients/berberin.webp",
    "img_desc": "/ingredients/berberin.webp",
    "amounts": {
      "cheat": 1
    },
    "amount_in_products": [],
    "overview": "Lowers blood sugar and cholesterol, supports weight loss, heart health, mental health, and may reduce cancer risk.",
    "derived_from": "The roots, rhizomes, and stem bark of various plants, including barberry and goldenseal.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 30925,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/34956436/",
        "t": "It lowers blood sugar levels"
      },
      {
        "l": "https://www.sciencedirect.com/science/article/abs/pii/S0944711312001870",
        "t": "May help you lose weight"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/30466986/",
        "t": "It lowers cholesterol and may reduce your risk of heart disease"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/36089660/",
        "t": "Animal studies suggest that it may help reduce symptoms of depression"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/34885950/",
        "t": "Test-tube and animal studies suggest that it can reduce the growth and spread of various types of cancer"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation"
  },
  {
    "handle": "ingredient-beta-sitosterol",
    "name": "Beta-Sitosterol",
    "img": "/ingredients/beta-sitosterol.webp",
    "img_desc": "/ingredients/beta-sitosterol.webp",
    "amounts": {
      "zeus": 130
    },
    "amount_in_products": [],
    "overview": "Provide antioxidant and anti-inflammatory benefits, may lower cholesterol, and reduce certain cancer risks.",
    "derived_from": "A plant sterol found in fruits, vegetables, nuts, and seeds.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 13344,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4567552/",
        "t": "Potent antioxidant and anti-inflammatory properties"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5729784/",
        "t": "Might reduce cholesterol levels"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/26086253/",
        "t": "May lower the risk of certain cancers"
      }
    ],
    "main_use_case": "Hormones, Men’s & Women’s Health"
  },
  {
    "handle": "ingredient-piperine",
    "name": "Black Pepper Extract Piperine",
    "img": "/ingredients/lhtenine.jpg",
    "img_desc": "/ingredient_description/bio_perrine.jpg",
    "amounts": {
      "advantage": 2,
      "shield": 2,
      "lucid": 5,
      "pro": 5,
      "bta": 10,
      "btr": 10,
      "btg": 10,
      "zeus": 2,
      "cheat": 0.2
    },
    "amount_in_products": [],
    "overview": "Rich in antioxidants; supports brain, blood sugar, cholesterol, and reduces inflammation.",
    "derived_from": "The fruits of the Piper nigrum plant.",
    "form": "Extract",
    "found_in": [
      "Black Pepper"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 2632,
    "highlighted_research": [
      {
        "title": "Piperine, the potential functional food for mood and cognitive disorders",
        "source": "Food and Chemical Toxicology"
      },
      {
        "title": "Effect of piperine, a major component of black pepper, on the intestinal absorption of fexofenadine and its implication on food-drug interaction",
        "source": "Journal of Food Science"
      }
    ],
    "benefits": [
      {
        "l": "https://www.nccih.nih.gov/health/antioxidant-supplements-what-you-need-to-know",
        "t": "High in antioxidants"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/30521241/",
        "t": "Has anti-inflammatory properties"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/21360003/",
        "t": "May benefit your brain"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/14517767/",
        "t": "May improve blood sugar control"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/28300080/",
        "t": "May lower cholesterol levels"
      }
    ],
    "main_use_case": "General Wellness, Digestion & Skin"
  },
  {
    "handle": "ingredient-blue-spirulina",
    "name": "Blue Spirulina",
    "img": "/ingredients/blue-spirulina.webp",
    "img_desc": "/ingredients/blue-spirulina.webp",
    "amounts": {
      "sprint": 40
    },
    "amount_in_products": [],
    "overview": "Strong antioxidant and anti-inflammatory effects, supports cholesterol, blood pressure, heart health, and may reduce cancer risk.",
    "derived_from": "A blue pigment (phycocyanin) isolated from the algae Arthrospira platensis.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 6822,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7938138/",
        "t": "Boasts powerful antioxidant and anti-inflammatory properties"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/26433766/",
        "t": "May lower cholesterol and triglyceride levels"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6466575/",
        "t": "Protects LDL cholesterol from oxidation"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9143897/",
        "t": "May have anti-cancer properties"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8468496/",
        "t": "May reduce blood pressure"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation"
  },
  {
    "handle": "ingredient-bromelain",
    "name": "Bromelain",
    "img": "/ingredients/bromelain.webp",
    "img_desc": "/ingredients/bromelain.webp",
    "amounts": {
      "zeus": 50
    },
    "amount_in_products": [],
    "overview": "Anti-inflammatory enzyme that may reduce pain, improve heart and respiratory health, support sinus relief, and have anticancer potential.",
    "derived_from": "The stems and fruit of the pineapple plant.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 4831,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC538506/",
        "t": "Effective treatment for the pain, soft-tissue swelling, and joint stiffness associated with osteoarthritis"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3529416/",
        "t": "Effective at treating cardiovascular diseases, such as peripheral artery disease, stroke, heart attack, and high blood pressure."
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/16337164/",
        "t": "Anti-inflammatory effects might be beneficial to people with asthma or other forms of allergic airway disease."
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/24273953/",
        "t": "Bromelain tablets were effective at alleviating swelling, congestion, and other symptoms associated with chronic sinusitis."
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/19700238/",
        "t": "Bromelain may have the ability to positively impact cancer cell growth"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Energy & Exercise"
  },
  {
    "handle": "ingredient-cdp-choline",
    "name": "CDP Choline",
    "img": "/ingredients/cdp-choline.webp",
    "img_desc": "/ingredients/cdp-choline.webp",
    "amounts": {
      "zeus": 50
    },
    "amount_in_products": [],
    "overview": "Enhances brain function, supports neurological conditions, mental health, and eye health (glaucoma).",
    "derived_from": "A naturally occurring choline source.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 5330,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8349115/",
        "t": "Memory and brain function"
      },
      {
        "l": "https://www.sciencedirect.com/science/article/abs/pii/S0011393X97800288",
        "t": "Neurological conditions"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5710031/",
        "t": "Glaucoma"
      },
      {
        "l": "https://www.sciencedirect.com/science/article/abs/pii/S0304394021004730?via%3Dihub",
        "t": "Mental health conditions"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-caffeine",
    "name": "Caffeine",
    "img": "/ingredients_pro/caffeine.jpg",
    "img_desc": "/ingredients_pro/caffeine.jpg",
    "amounts": {
      "pro": 40,
      "sprint": 100
    },
    "amount_in_products": [],
    "overview": "Boosts mood, focus, metabolism, exercise performance, and may protect heart, liver, and metabolic health.",
    "derived_from": "The seeds, leaves, and fruits of various plants, including coffee beans and tea leaves.",
    "form": "",
    "found_in": [
      "Leaves and Fruits of Some Plants"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 123994,
    "highlighted_research": [
      {
        "title": "Serum caffeine and metabolites are reliable biomarkers of early Parkinson disease",
        "source": "National Library of Medicine"
      },
      {
        "title": "What Should We Do About Habitual Caffeine Use in Athletes?",
        "source": "National Library of Medicine"
      },
      {
        "title": "Caffeine intake is related to successful weight loss maintenance",
        "source": "National Library of Medicine"
      },
      {
        "title": "The effects of L-theanine, caffeine and their combination on cognition and mood",
        "source": "National Library of Medicine"
      }
    ],
    "benefits": [
      {
        "l": "https://onlinelibrary.wiley.com/doi/abs/10.1111/j.1600-0773.1995.tb00111.x",
        "t": "May improve mood and brain function"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/7369170/",
        "t": "May boost metabolism and fat burning"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/723503/",
        "t": "May enhance exercise performance"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/23871889/",
        "t": "May protect against heart disease and diabetes"
      },
      {
        "l": "https://onlinelibrary.wiley.com/doi/full/10.1111/liv.12304",
        "t": "Liver protection"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / Energy & Exercise"
  },
  {
    "handle": "ingredient-chamomile",
    "name": "Chamomile",
    "img": "/ingredients_lucid/chamomile.jpg",
    "img_desc": "/ingredient_description/chamomile.jpg",
    "amounts": {
      "lucid": 24
    },
    "amount_in_products": [],
    "overview": "Promotes sleep, digestion, heart and blood sugar health, with possible anticancer benefits.",
    "derived_from": "The dried flowers of the Matricaria chamomilla plant.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 7214,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/38476603/",
        "t": "May improve sleep quality"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/24463157/",
        "t": "May promote digestive health"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5207605/",
        "t": "May protect against certain types of cancer"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8212264/",
        "t": "May benefit blood sugar control"
      },
      {
        "l": "https://www.mdpi.com/2218-0532/91/4/55",
        "t": "May benefit heart health"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / General Wellness, Digestion & Skin"
  },
  {
    "handle": "ingredient-choline-bitartrate",
    "name": "Choline Bitartrate",
    "img": "/ingredients_shield/choline_bitrarte.png",
    "img_desc": "/ingredient_description/n-acetyl_l-tyrosine.jpg",
    "derived_from": "A salt form of choline.",
    "amounts": {
      "advantage": 250,
      "shield": 300,
      "pro": 250
    },
    "amount_in_products": [],
    "overview": "Essential nutrient for cell structure, liver health, DNA synthesis, neurotransmitter production, and nervous system function.",
    "form": "Bitartrate ",
    "found_in": [
      "Nuts, Beans, Vegetables"
    ],
    "manufactured_in": "Made in Europe",
    "number_of_studies": 144419,
    "highlighted_research": [
      {
        "title": "Improved human visuomotor performance and pupil constriction after choline supplementation in a placebo-controlled double-blind study",
        "source": "Scientific Reports"
      },
      {
        "title": "Effects of Choline and Magnesium Concurrent Supplementation on Coagulation and Lipid Profile in Patients with Type 2 Diabetes Mellitus: a Pilot Clinical Trial",
        "source": "Biological Trace Element Research"
      },
      {
        "title": "Time-course microarrays reveal early activation of the immune transcriptome in a choline-deficient mouse model of liver injury",
        "source": "Life Sciences"
      },
      {
        "title": "Lifelong choline supplementation ameliorates Alzheimers disease pathology and associated cognitive deficits by attenuating microglia activation",
        "source": "Aging Cell"
      }
    ],
    "benefits": [
      {
        "l": "https://ods.od.nih.gov/factsheets/Choline-HealthProfessional/",
        "t": "Cell structure: It is needed to make fats that support the structural integrity of cell membranes."
      },
      {
        "l": "https://ods.od.nih.gov/factsheets/Choline-HealthProfessional/",
        "t": "Cell messaging: It is involved in the production of compounds that act as cell messengers."
      },
      {
        "l": "https://ods.od.nih.gov/factsheets/Choline-HealthProfessional/",
        "t": "Fat transport and metabolism: It is essential for making a substance required for removing cholesterol from your liver. Inadequate choline may result in fat and cholesterol buildup in your liver."
      },
      {
        "l": "https://ods.od.nih.gov/factsheets/Choline-HealthProfessional/",
        "t": "DNA synthesis: Choline and other vitamins, such as B12 and folate, help with a process that’s important for DNA synthesis."
      },
      {
        "l": "https://ods.od.nih.gov/factsheets/Choline-HealthProfessional/",
        "t": "A healthy nervous system: This nutrient is required to make acetylcholine, an important neurotransmitter. It’s involved in memory, muscle movement, regulating heartbeat and other basic functions."
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-chromium-picolinate-powder",
    "name": "Chromium Picolinate Powder",
    "img": "/ingredients/chromium-picolinate.webp",
    "img_desc": "/ingredients/chromium-picolinate.webp",
    "derived_from": "The mineral chromium and picolinic acid.",
    "amounts": {
      "cheat": 100
    },
    "amount_in_products": [],
    "overview": "May improve blood sugar regulation and reduce hunger/cravings.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 808,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/24635480/",
        "t": "It May Improve Blood Sugar"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/18715218/",
        "t": "It May Reduce Hunger and Cravings"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation"
  },
  {
    "handle": "ingredient-cinnamon-extract",
    "name": "Cinnamon Extract",
    "img": "/ingredients/cinnamon.webp",
    "img_desc": "/ingredients/cinnamon.webp",
    "derived_from": "The bark of trees from the genus Cinnamomum.",
    "amounts": {
      "advantage": 120,
      "cheat": 180
    },
    "amount_in_products": [],
    "overview": "Potent antioxidant and anti-inflammatory; supports blood sugar control, insulin sensitivity, and heart health.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 19922,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31960481/",
        "t": "Loaded with antioxidants"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7147972/",
        "t": "May have anti-inflammatory properties"
      },
      {
        "l": "https://www.who.int/news-room/fact-sheets/detail/the-top-10-causes-of-death",
        "t": "Could protect against heart disease"
      },
      {
        "l": "https://www.ncbi.nlm.nih.gov/books/NBK560688/",
        "t": "Could improve sensitivity to insulin"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/32326848/",
        "t": "Helps lower blood sugar levels"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation"
  },
  {
    "handle": "ingredient-curcumin-95",
    "name": "Curcumin 95%",
    "img": "/ingredients/curcumin.webp",
    "img_desc": "/ingredients/curcumin.webp",
    "derived_from": "The roots of the Curcuma longa plant, also known as turmeric.",
    "amounts": {
      "advantage": 40
    },
    "amount_in_products": [],
    "overview": "Strong anti-inflammatory and antioxidant properties; supports wound healing, bone health, and disease prevention.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 50180,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3918523/",
        "t": "Shown to have strong anti-inflammatory effects"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5854386/",
        "t": "Shown to have strong anti-oxidant effects"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/19110321/",
        "t": "Support wound healing through its antibacterial effects"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC2945868/",
        "t": "It may also reduce osteoporosis risk."
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Immunity & Inflammation / General Wellness"
  },
  {
    "handle": "ingredient-echinacea",
    "name": "Echinacea Purpurea Extract",
    "img": "/ingredients_shield/echinacea.png",
    "img_desc": "/ingredient_description/echinacea.jpg",
    "derived_from": "The roots, leaves, and flowers of the Echinacea purpurea plant.",
    "amounts": {
      "shield": 100
    },
    "amount_in_products": [],
    "overview": "Immune-boosting herb with anti-inflammatory, skin, blood sugar, and anxiety-relieving properties.",
    "form": "Extract",
    "found_in": [
      "North America"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 276,
    "highlighted_research": [
      {
        "title": "Fructans as Immunomodulatory and Antiviral Agents: The Case of Echinacea",
        "source": "Biomolecules"
      },
      {
        "title": "Echinacea plants as antioxidant and antibacterial agents: From traditional medicine to biotechnological applications",
        "source": "Phytotherapy Research"
      },
      {
        "title": "Self-Care for Common Colds: The Pivotal Role of Vitamin D, Vitamin C, Zinc, and Echinacea in Three Main Immune Interactive Clusters (Physical Barriers, Innate and Adaptive Immunity) Involved during an Episode of Common Colds-Practical Advice on Dosages and on the Time to Take These Nutrients/Botanicals in order to Prevent or Treat Common Colds",
        "source": "Evidence Based, Complimentary and Alternative Medicine - eCAM"
      },
      {
        "title": "Studies on phytochemical, antioxidant, anti-inflammatory, hypoglycaemic and antiproliferative activities of Echinacea purpurea and Echinacea angustifolia extracts",
        "source": "Pharmaceutical Biology"
      },
      {
        "title": "Immune system effects of echinacea, ginseng, and astragalus: a review",
        "source": "Integrative Cancer Therapies"
      }
    ],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/23195946/",
        "t": "Positive effect on the immune system"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/28061036/",
        "t": "May lower blood sugar levels"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7441973/",
        "t": "May reduce feelings of anxiety"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7147972/",
        "t": "Anti-inflammatory properties"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8850513/",
        "t": "May help treat skin concerns"
      }
    ],
    "main_use_case": "Immunity & Inflammation"
  },
  {
    "handle": "ingredient-folic-acid",
    "name": "Folic Acid",
    "img": "/ingredients/folic-acid.webp",
    "img_desc": "/ingredients/folic-acid.webp",
    "derived_from": "A synthetic form of folate (Vitamin B9).",
    "amounts": {
      "sprint": 0.8
    },
    "amount_in_products": [],
    "overview": "Crucial for pregnancy health, brain and mental function, heart health, and diabetes management.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 105205,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://ods.od.nih.gov/factsheets/Folate-Consumer/",
        "t": "Preventing birth defects and pregnancy complications"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29255930/",
        "t": "Maintaining brain health"
      },
      {
        "l": "https://ods.od.nih.gov/factsheets/Folate-Consumer/",
        "t": "Treating mental health conditions"
      },
      {
        "l": "https://ods.od.nih.gov/factsheets/Folate-HealthProfessional/",
        "t": "Reducing heart disease risk factors"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8198407/",
        "t": "Diabetes. Folate supplements may help improve blood sugar regulation and reduce insulin resistance in people with diabetes."
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Hormones, Men’s & Women’s Health"
  },
  {
    "handle": "ingredient-ginkgo-biloba-leaf-extract",
    "name": "Ginkgo Biloba Leaf Extract",
    "img": "/ingredients/ginkgo-biloba-leaf.webp",
    "img_desc": "/ingredients/ginkgo-biloba-leaf.webp",
    "derived_from": "The leaves of the Ginkgo biloba tree.",
    "amounts": {},
    "amount_in_products": [],
    "overview": "Antioxidant-rich herb that reduces inflammation, supports heart, brain, and mental health, and improves circulation.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 8969,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/32349345/",
        "t": "Contains powerful antioxidants"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5758353/",
        "t": "Helps reduce inflammation"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/18446847/",
        "t": "Improves circulation and heart health"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/26268332/",
        "t": "Reduces symptoms of psychiatric disorders and dementia"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/12404671/",
        "t": "Improves brain function and well-being"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-organic-panax-ginseng",
    "name": "Ginseng Extract Ginsenosides",
    "img": "/ingredients_shield/organic_panax_ginseng.png",
    "img_desc": "/ingredient_description/organic_panax_ginseng.jpg",
    "derived_from": "The roots of plants in the genus Panax.",
    "amounts": {
      "shield": 100,
      "sprint": 50,
      "cheat": 145
    },
    "amount_in_products": [],
    "overview": "Adaptogen with antioxidant properties that support brain function, immunity, sexual health, and may reduce cancer risk.",
    "form": "Extract",
    "found_in": [
      "Panax Ginseng Root"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 12166,
    "highlighted_research": [
      {
        "title": "Anti-Cancer Effects of Panax ginseng Berry Polysaccharides via Activation of Immune-Related Cells",
        "source": "Frontiers in Pharmacology"
      },
      {
        "title": "Systematic exploration of Astragalus membranaceus and Panax ginseng as immune regulators: Insights from the comparative biological and computational analysis",
        "source": "Phytomedicine"
      },
      {
        "title": "The antimicrobial properties of ginseng and ginseng extracts",
        "source": "Expert review of Anti-Infective Therapy"
      },
      {
        "title": "Effects of ginseng on stress-related depression, anxiety, and the hypothalamic-pituitary-adrenal axis",
        "source": "Journal of Ginseng Research"
      }
    ],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8746757/",
        "t": "Contains antioxidants that may reduce inflammation"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5968575/",
        "t": "May benefit brain function"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8753520/",
        "t": "Could improve erectile dysfunction"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7790873/",
        "t": "May boost the immune system"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7875636/",
        "t": "May have potential benefits against cancer"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / Immunity & Inflammation"
  },
  {
    "handle": "ingredient-green-spirulina",
    "name": "Green Spirulina",
    "img": "/ingredients/green-spirulina.webp",
    "img_desc": "/ingredients/green-spirulina.webp",
    "derived_from": "The algae Arthrospira platensis.",
    "amounts": {},
    "amount_in_products": [],
    "overview": "Strong antioxidant and anti-inflammatory effects, supports cholesterol, blood pressure, heart health, and may reduce cancer risk.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 9159,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7938138/",
        "t": "Boasts powerful antioxidant and anti-inflammatory properties"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/26433766/",
        "t": "May lower cholesterol and triglyceride levels"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6466575/",
        "t": "Protects LDL cholesterol from oxidation"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9143897/",
        "t": "May have anti-cancer properties"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8468496/",
        "t": "May reduce blood pressure"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation"
  },
  {
    "handle": "ingredient-green-tea-extract-tea-polyphenols",
    "name": "Green Tea Extract Tea Polyphenols",
    "img": "/ingredients/green-tea-extract-tea.webp",
    "img_desc": "/ingredients/green-tea-extract-tea.webp",
    "derived_from": "The leaves of the Camellia sinensis plant.",
    "amounts": {
      "zeus": 200
    },
    "amount_in_products": [],
    "overview": "Antioxidant-rich supplement that supports brain, heart, liver health, weight loss, and overall well-being.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 52600,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/25547095/",
        "t": "High in antioxidants"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/24976907/",
        "t": "May promote heart health"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/33466849/",
        "t": "Good for the brain"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/21115335/",
        "t": "Can help with weight loss"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/26955458/",
        "t": "Might benefit liver function"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation"
  },
  {
    "handle": "ingredient-holy-basil-leaf-extract",
    "name": "Holy Basil Leaf Extract",
    "img": "/ingredients_lucid/holy-basil-leaf-extract.jpg",
    "img_desc": "/ingredient_description/holy-basil-leaf-extract.jpg",
    "derived_from": "The leaves of the Ocimum tenuiflorum plant, also known as Tulsi.",
    "amounts": {
      "lucid": 50
    },
    "amount_in_products": [],
    "overview": "Adaptogenic herb that supports brain, mood, heart, blood sugar, cholesterol, and blood pressure health.",
    "form": "Synthetic",
    "found_in": [
      "Ocimum tenuiflorum"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 9,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29356981/",
        "t": "Reduce memory loss associated with stress and aging"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/28800278/",
        "t": "Reduce depression related to chronic stress"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29546690/",
        "t": "Reduce stroke damage and support recovery, whether given before or right after a stroke"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/28163956/",
        "t": "Improve fasting blood sugar, cholesterol and triglycerides"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/20448636/",
        "t": "Reduce blood pressure in people with hypertension"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / General Wellness"
  },
  {
    "handle": "ingredient-hops",
    "name": "Hops (Humulus lupulus)",
    "img": "/ingredients_lucid/hops.jpg",
    "img_desc": "/ingredient_description/hops.jpg",
    "derived_from": "The flowers of the Humulus lupulus plant.",
    "amounts": {
      "lucid": 100
    },
    "amount_in_products": [],
    "overview": "May promote relaxation, reduce anxiety, and improve sleep quality.",
    "form": "Synthetic",
    "found_in": [
      "Humulus Lupulus"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 4249,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://onlinelibrary.wiley.com/doi/10.1111/nhs.12898",
        "t": "Shown promise for relieving anxiety and sleep disorders"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / General Wellness"
  },
  {
    "handle": "ingredient-huperzine-a",
    "name": "Huperzine A",
    "img": "/ingredients/huperzine_a.jpg",
    "img_desc": "/ingredient_description/huperzine_a.jpg",
    "derived_from": "The firmoss plant Huperzia serrata.",
    "amounts": {
      "advantage": 0.2,
      "lucid": 0.4,
      "pro": 0.1
    },
    "amount_in_products": [],
    "overview": "",
    "form": "Extract",
    "found_in": [
      "Fir Club Moss Plants"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 74,
    "highlighted_research": [
      {
        "title": "Huperzine A for Alzheimers disease: a systematic review and meta-analysis of randomized clinical trials",
        "source": "PLoS One"
      },
      {
        "title": "Efficacy and safety of huperzine A in treating patients with mild cognitive impairment: a systematic review and Meta-analysis",
        "source": "China Journal of Chinese Material Medicine "
      },
      {
        "title": "Huperzine A",
        "source": "Drugs in R&D"
      }
    ],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31560162/",
        "t": "May aid memory and brain function"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/19656836/",
        "t": "May support mental health"
      },
      {
        "l": "https://ods.od.nih.gov/factsheets/Choline-HealthProfessional/",
        "t": "May support a healthy pregnancy"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/22134222/",
        "t": "Liver disease. A choline deficiency may cause liver disease, and higher choline intakes may be linked to a lower risk of liver disease and liver cancers"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/27550622/",
        "t": "Heart disease. There’s some evidence that shows that choline may lower the risk of heart disease and stroke."
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-iron-gluconate",
    "name": "Iron Gluconate",
    "img": "/ingredients/iron-gluconate.webp",
    "img_desc": "/ingredients/iron-gluconate.webp",
    "derived_from": "A form of iron derived from the mineral iron and gluconic acid.",
    "amounts": {
      "bta": 8,
      "btr": 8,
      "btg": 8
    },
    "amount_in_products": [],
    "overview": "Essential for energy, endurance, and a healthy pregnancy.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 287,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://www.ucsfhealth.org/education/hemoglobin-and-functions-of-iron",
        "t": "Energy"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4596414/",
        "t": "Physical performance and endurance"
      },
      {
        "l": "https://journals.sagepub.com/doi/10.1177/1178626417737738",
        "t": "Healthy pregnancy"
      }
    ],
    "main_use_case": "Energy, Exercise & Recovery"
  },
  {
    "handle": "ingredient-alpha-gpc",
    "name": "L-Alpha-GPC 99%",
    "img": "/ingredients_shield/alpha_gpc.png",
    "img_desc": "/ingredient_description/alpha_gpc.jpg",
    "derived_from": "A compound derived from soy or sunflower lecithin.",
    "amounts": {
      "advantage": 120,
      "shield": 100,
      "pro": 150,
      "cheat": 220
    },
    "amount_in_products": [],
    "overview": "Supports brain function, mental health, and pregnancy through choline metabolism.",
    "form": "Synthetic",
    "found_in": [
      "Sunflower Lecithi"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 2,
    "highlighted_research": [
      {
        "title": "The effect of 6 days of alpha glycerylphosphorylcholine on isometric strength",
        "source": "Journal of International Society of Sports Nutrition"
      },
      {
        "title": "Evaluation of the effects of two doses of alpha glycerylphosphorylcholine on physical and psychomotor performance",
        "source": "Journal of International Society of Sports Nutrition"
      },
      {
        "title": "Glycerophosphocholine enhances growth hormone secretion and fat oxidation in young adults",
        "source": "Nutrition, California"
      },
      {
        "title": "Late treatment with choline alfoscerate (l-alpha glycerylphosphorylcholine, α-GPC) increases hippocampal neurogenesis and provides protection against seizure-induced neuronal death and cognitive impairment",
        "source": "Brain Research"
      }
    ],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31560162/",
        "t": "May aid memory and brain function"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/19656836/",
        "t": "May support mental health"
      },
      {
        "l": "https://ods.od.nih.gov/factsheets/Choline-HealthProfessional/",
        "t": "May support a healthy pregnancy"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-l-glutamine",
    "name": "L-Glutamine",
    "img": "/ingredients/l-glutamine.webp",
    "img_desc": "/ingredients/l-glutamine.webp",
    "derived_from": "A naturally occurring amino acid.",
    "amounts": {
      "shield": 403,
      "pro": 312.89
    },
    "amount_in_products": [],
    "overview": "Important for immunity, gut health, and muscle performance.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 474302,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC2642618/",
        "t": "It Is Important for the Immune System"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/25163502/",
        "t": "It Plays a Role in Intestinal Health"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/11822473/",
        "t": "Effects on Muscle Gain and Exercise Performance"
      }
    ],
    "main_use_case": "Energy, Exercise & Recovery"
  },
  {
    "handle": "ingredient-l-glutathione",
    "name": "L-Glutathione",
    "img": "/ingredients/l-glutathione.webp",
    "img_desc": "/ingredients/l-glutathione.webp",
    "derived_from": "A peptide composed of three amino acids: glutamic acid, cysteine, and glycine.",
    "amounts": {
      "btg": 600
    },
    "amount_in_products": [],
    "overview": "Powerful antioxidant that reduces oxidative stress, improves liver health, insulin resistance, mobility, and skin conditions.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 388454,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://www.cancer.gov/publications/dictionaries/cancer-terms/def/oxidative-stress",
        "t": "Reduces oxidative stress"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8863102/",
        "t": "May improve psoriasis"
      },
      {
        "l": "https://www.sciencedirect.com/science/article/pii/S1818087622001015",
        "t": "Reduces cell damage in fatty liver disease"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/33740389/",
        "t": "Improves insulin resistance"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5880878/",
        "t": "Increases mobility for people with peripheral artery disease"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / General Wellness"
  },
  {
    "handle": "ingredient-l-theanine",
    "name": "L-Theanine",
    "img": "/ingredients_shield/l-theanine.png",
    "img_desc": "/ingredient_description/l-theanine.jpg",
    "derived_from": "An amino acid primarily found in green and black tea leaves.",
    "amounts": {
      "advantage": 200,
      "shield": 150,
      "lucid": 80,
      "pro": 200,
      "sprint": 100,
      "cheat": 70
    },
    "amount_in_products": [],
    "overview": "Promotes relaxation, focus, immunity, and may support cancer prevention and blood pressure health.",
    "form": "Suntheanin",
    "found_in": [
      "Camellia sinensis (Green Tea)"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 3734,
    "highlighted_research": [
      {
        "title": "L-Theanine reduces psychological and physiological stress responses",
        "source": "Biological Psychology"
      },
      {
        "title": "Effects of L-Theanine Administration on Stress-Related Symptoms and Cognitive Functions in Healthy Adults: A Randomized Controlled Trial",
        "source": "Nutrients"
      },
      {
        "title": "The combination of L-theanine and caffeine improves cognitive performance and increases subjective alertness",
        "source": "Nutritional Neuroscience"
      },
      {
        "title": "Effects of chronic l-theanine administration in patients with major depressive disorder: an open-label study",
        "source": "Acta Neuropsychiatrica"
      }
    ],
    "benefits": [
      {
        "l": "https://www.sciencedirect.com/science/article/pii/S2352385915003138?via%3Dihub",
        "t": "Anxiety and stress relief"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/21040626/",
        "t": "Increased focus"
      },
      {
        "l": "https://www.mdpi.com/2306-5710/2/2/13",
        "t": "Better immunity"
      },
      {
        "l": "https://aacrjournals.org/cebp/article/15/12_Supplement/A157/229855/L-Theanine-in-cancer-prevention-and-treatment",
        "t": "Tumor and cancer treatment"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3518171/",
        "t": "Blood pressure management"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / Energy & Exercise"
  },
  {
    "handle": "ingredient-l-tryptophan",
    "name": "L-Tryptophan",
    "img": "/ingredients_lucid/l-tryptophan.jpeg",
    "img_desc": "/ingredient_description/l-tryptophan.jpeg",
    "derived_from": "An essential amino acid found in many protein-rich foods.",
    "amounts": {
      "lucid": 80
    },
    "amount_in_products": [],
    "overview": "Supports sleep, mood, emotional well-being, and pain tolerance.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 230089,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "http://shine365.marshfieldclinic.org/wellness/sleepy-after-turkey/",
        "t": "Healthier and better quality sleep"
      },
      {
        "l": "",
        "t": "Relief from depression and anxiety"
      },
      {
        "l": "",
        "t": "Increased emotional well-being"
      },
      {
        "l": "",
        "t": "Strengthened pain tolerance"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-l-tyrosine",
    "name": "L-Tyrosine",
    "img": "/ingredients/l-tyrosine.webp",
    "img_desc": "/ingredients/l-tyrosine.webp",
    "derived_from": "A naturally occurring amino acid.",
    "amounts": {
      "sprint": 100
    },
    "amount_in_products": [],
    "overview": "May improve mental performance under stress and support people with phenylketonuria",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 741088,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3697199/",
        "t": "It May Improve Mental Performance in Stressful Situations"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4728993/",
        "t": "It Might Help Those With Phenylketonuria"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-lavender",
    "name": "Lavender",
    "img": "/ingredients_lucid/lavender.jpg",
    "img_desc": "/ingredient_description/lavender.jpg",
    "derived_from": "The flowering tops of the Lavandula angustifolia plant.",
    "amounts": {
      "lucid": 150
    },
    "amount_in_products": [],
    "overview": "Calming herb that supports sleep, anxiety relief, hair growth, pain relief, and cancer-related symptom management.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 21054,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/24720812/",
        "t": "Could improve sleep quality"
      },
      {
        "l": "https://www.nature.com/articles/s41598-019-54529-9",
        "t": "Lavender may also provide support for people with anxiety."
      },
      {
        "l": "https://jamanetwork.com/journals/jamadermatology/fullarticle/189618",
        "t": "Topical use of lavender oil might help to treat a disease called alopecia aerata, which causes a person’s hair to fall out in patches."
      },
      {
        "l": "https://www.sciencedirect.com/science/article/abs/pii/S2210803316300033",
        "t": "The calming effects of lavender might be enough to soothe away a headache or migraine."
      },
      {
        "l": "https://www.cancer.gov/about-cancer/treatment/cam/patient/aromatherapy-pdq#section/all",
        "t": "According to the National Cancer InstituteTrusted Source, aromatherapy can help people with cancer manage the side effects of their treatment."
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / General Wellness"
  },
  {
    "handle": "ingredient-lemon-balm-extract",
    "name": "Lemon Balm Extract",
    "img": "/ingredients_lucid/lemon-balm-extract.jpg",
    "img_desc": "/ingredient_description/lemon-balm-extract.jpg",
    "derived_from": "The leaves of the Melissa officinalis plant.",
    "amounts": {
      "lucid": 64
    },
    "amount_in_products": [],
    "overview": "Reduces stress and anxiety, improves sleep and cognition, supports digestion, skin, and cold sore treatment.",
    "form": "Synthetic",
    "found_in": [
      "Melissa officinalis"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 261,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://www.imrpress.com/journal/FBS/14/2/10.31083/j.fbs1402016/htm",
        "t": "Lemon balm may help relieve stress and anxiety"
      },
      {
        "l": "https://www.imrpress.com/journal/FBS/14/2/10.31083/j.fbs1402016/htm",
        "t": "Lemon balm may improve cognitive function"
      },
      {
        "l": "https://www.sciencedirect.com/science/article/abs/pii/S1876382018309892",
        "t": "Lemon balm may help ease insomnia and support restful sleep"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9841880/",
        "t": "Lemon balm may help treat cold sores"
      },
      {
        "l": "https://www.sciencedirect.com/science/article/pii/S1756464623001500",
        "t": "Lemon balm may help relieve indigestion"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / General Wellness"
  },
  {
    "handle": "ingredient-lions-mane",
    "name": "Lions Mane",
    "img": "/ingredients/lion-mane.webp",
    "img_desc": "/ingredients/lion-mane.webp",
    "derived_from": "The mushroom Hericium erinaceus.",
    "amounts": {},
    "amount_in_products": [],
    "overview": "Supports brain, mood, nervous system recovery, digestion, and heart health.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 170,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6128435/",
        "t": "Could protect against dementia"
      },
      {
        "l": "https://www.frontiersin.org/journals/psychiatry/articles/10.3389/fpsyt.2021.714014/full",
        "t": "Helps relieve mild symptoms of depression and anxiety"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/26853959/",
        "t": "May speed recovery from nervous system injuries"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6140150/",
        "t": "Protects against ulcers in the digestive tract"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3714447/",
        "t": "Reduces risk of heart disease"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-lycopene",
    "name": "Lycopene",
    "img": "/ingredients/lycopene.webp",
    "img_desc": "/ingredients/lycopene.webp",
    "derived_from": "A red carotenoid pigment found in fruits and vegetables, particularly tomatoes.",
    "amounts": {
      "zeus": 30
    },
    "amount_in_products": [],
    "overview": "Antioxidant that supports heart, skin, eye, and cancer protection.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 24702,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/26231422/",
        "t": "Strong Antioxidant Properties"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/26779636/",
        "t": "May Protect Against Certain Types of Cancer"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/16762935/",
        "t": "May Promote Heart Health"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/20637178/",
        "t": "May Protect Against Sunburn"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/12921892/",
        "t": "May help your eyesight"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / General Wellness"
  },
  {
    "handle": "ingredient-magnesium-as-magnesium-oxide",
    "name": "Magnesium (as Magnesium Oxide)",
    "img": "/ingredients/magnesium.webp",
    "img_desc": "/ingredients/magnesium.webp",
    "derived_from": "The mineral magnesium and oxygen.",
    "amounts": {
      "zeus": 100
    },
    "amount_in_products": [],
    "overview": "May reduce headaches, stress, blood sugar, blood pressure, and improve digestion.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 73746,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://link.springer.com/article/10.1007/s12011-019-01931-z",
        "t": "May help treat headaches"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5452159/",
        "t": "May reduce stress and anxiety"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6786451/",
        "t": "Helps treat constipation"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5986461/",
        "t": "May lower blood pressure"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7257447/",
        "t": "May lower blood sugar levels"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / General Wellness"
  },
  {
    "handle": "ingredient-magnesium-glycinate",
    "name": "Magnesium Glycinate",
    "img": "/ingredients_lucid/magnesium-glycinate.jpeg",
    "img_desc": "/ingredient_description/magnesium-glycinate.jpg",
    "derived_from": "The mineral magnesium and the amino acid glycine.",
    "amounts": {
      "lucid": 100
    },
    "amount_in_products": [],
    "overview": "Supports stress relief, bone health, blood sugar, heart health, and PMS symptoms.",
    "form": "Synthetic",
    "found_in": [
      "Seawater"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 82,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "",
        "t": "Relieve anxiety"
      },
      {
        "l": "",
        "t": "Promote bone health"
      },
      {
        "l": "",
        "t": "Manage blood sugar in people with diabetes and may lower the risk of developing type 2 diabetes"
      },
      {
        "l": "",
        "t": "Maintain regular heart rhythms"
      },
      {
        "l": "",
        "t": "Reduce symptoms of premenstrual syndrome (PMS)"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / General Wellness"
  },
  {
    "handle": "ingredient-magnolia-bark",
    "name": "Magnolia Bark",
    "img": "/ingredients_lucid/magnolia-bark.jpg",
    "img_desc": "/ingredient_description/magnolia-bark.jpg",
    "derived_from": "The bark of the Magnolia officinalis tree.",
    "amounts": {
      "lucid": 24
    },
    "amount_in_products": [],
    "overview": "Antioxidant herb with anticancer, stress-relieving, sleep, and menopause symptom benefits.",
    "form": "Synthetic",
    "found_in": [
      "Houpo Magnolia tree"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 2657,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/27738491/",
        "t": "May protect against the effects of oxidative stress and inflammation"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31877856/",
        "t": "May have anticancer properties"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/24062717/",
        "t": "May relieve stress and anxiety"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/22771461/",
        "t": "May improve sleep"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/24951101/",
        "t": "May improve symptoms of menopause"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / Hormones, Men’s & Women’s Health / Immunity & Inflammation"
  },
  {
    "handle": "ingredient-montmorency-cherry",
    "name": "Montmorency Cherry",
    "img": "/ingredients_lucid/montmorency-cherry.jpg",
    "img_desc": "/ingredient_description/montmorency-cherry.jpg",
    "derived_from": "The fruit of the Prunus cerasus tree.",
    "amounts": {
      "lucid": 740.3
    },
    "amount_in_products": [],
    "overview": "Enhances sleep, exercise recovery, brain health, immunity, and may reduce gout symptoms.",
    "form": "Synthetic",
    "found_in": [
      "Montmorency Cherry"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 549,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/20459662/",
        "t": "May increase strength and reduce muscle soreness"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5617749/",
        "t": "Could help you sleep better"
      },
      {
        "l": "https://www.ncbi.nlm.nih.gov/books/NBK546606/",
        "t": "May reduce symptoms of gout"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31829802/",
        "t": "Might promote brain health"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/25983669/",
        "t": "May strengthen the immune system"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Energy & Exercise"
  },
  {
    "handle": "ingredient-mulberry-leaf-extract",
    "name": "Mulberry Leaf Extract",
    "img": "/ingredients/mulberry-leaf.webp",
    "img_desc": "/ingredients/mulberry-leaf.webp",
    "derived_from": "The leaves of the Morus alba tree.",
    "amounts": {
      "cheat": 290
    },
    "amount_in_products": [],
    "overview": "Supports blood sugar, heart, liver, and immune health, with potential anticancer benefits.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 15411,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5321430/",
        "t": "May lower blood sugar and insulin"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6130672/",
        "t": "May promote heart health"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9322217/",
        "t": "May reduce inflammation"
      },
      {
        "l": "",
        "t": "Liver health"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6412198/",
        "t": "Anticancer effects"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Immunity & Inflammation"
  },
  {
    "handle": "ingredient-n-acetyl-l-tyrosine",
    "name": "N-Acetyl L-Tyrosine",
    "img": "/ingredients/sulbutiamine.jpg",
    "img_desc": "/ingredient_description/n-acetyl_l-tyrosine.jpg",
    "derived_from": "An acetylated form of the amino acid L-tyrosine.",
    "amounts": {
      "advantage": 50,
      "pro": 50
    },
    "amount_in_products": [],
    "overview": "",
    "form": "Extract",
    "found_in": [
      "Beans, Oats and Wheat"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 779,
    "highlighted_research": [
      {
        "title": "Tyrosine hydroxylase: human isoforms, structure and regulation in physiology and pathology",
        "source": "Essays in Biochemistry"
      },
      {
        "title": "Treatment with tyrosine, a neurotransmitter precursor, reduces environmental stress in humans",
        "source": "Brain Research Bulletin"
      },
      {
        "title": "Effects of acute ingestion of a pre-workout dietary supplement with and without p- synephrine on resting energy expenditure, cognitive function and exercise performance",
        "source": "Journal of the International Society of Sports Nutrition"
      }
    ],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3697199/",
        "t": "It May Improve Mental Performance in Stressful Situations"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4728993/",
        "t": "It Might Help Those With Phenylketonuria"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-nettle-extract",
    "name": "Nettle Extract",
    "img": "/ingredients/nettle-extract.webp",
    "img_desc": "/ingredients/nettle-extract.webp",
    "derived_from": "The leaves and roots of the Urtica dioica plant.",
    "amounts": {
      "zeus": 200
    },
    "amount_in_products": [],
    "overview": "Reduces inflammation, supports prostate, heart, blood sugar, and allergy relief.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 6848,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/9923611/",
        "t": "May Reduce Inflammation"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/16985920/",
        "t": "May Treat Enlarged Prostate Symptoms"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/19140159/",
        "t": "May Treat Hay Fever"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/27585814/",
        "t": "May Lower Blood Pressure"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29749986/",
        "t": "May Aid Blood Sugar Control"
      }
    ],
    "main_use_case": "Immunity & Inflammation / Hormones, Men’s & Women’s Health"
  },
  {
    "handle": "ingredient-organic-elderberry",
    "name": "Organic Elderberry",
    "img": "/ingredients_shield/elderberry.png",
    "img_desc": "/ingredient_description/elderberry.jpg",
    "derived_from": "The berries of the Sambucus nigra plant.",
    "amounts": {
      "shield": 50
    },
    "amount_in_products": [],
    "overview": "Rich in antioxidants that support immune, heart, antibacterial, and anticancer health.",
    "form": "Sambucus Nigra",
    "found_in": [
      "Organic Elderberry"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 4096,
    "highlighted_research": [
      {
        "title": "Sambucus nigra extracts inhibit infectious bronchitis virus at an early point during replication",
        "source": "BMC Veterinary Research"
      },
      {
        "title": "Black elderberry (Sambucus nigra) supplementation effectively treats upper respiratory symptoms: A meta-analysis of randomized, controlled clinical trials",
        "source": "Complimentary Therapies in Medicine"
      },
      {
        "title": "Anti-influenza virus effects of elderberry juice and its fractions",
        "source": "Bioscience, Biotechnology, Biochemical"
      },
      {
        "title": "Elderberry Supplementation Reduces Cold Duration and Symptoms in Air-Travellers: A Randomized, Double-Blind Placebo-Controlled Clinical Trial",
        "source": "Nutrients"
      }
    ],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/28198157/",
        "t": "May improve cold and flu symptoms"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3093095/",
        "t": "High in antioxidants"
      },
      {
        "l": "https://onlinelibrary.wiley.com/doi/abs/10.1002/ptr.2729",
        "t": "May be good for heart health"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/28198157/",
        "t": "Helps fight cancer"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/28198157/",
        "t": "Fights harmful bacteria"
      }
    ],
    "main_use_case": "Immunity & Inflammation"
  },
  {
    "handle": "ingredient-organic-ginger-extract",
    "name": "Organic Ginger",
    "img": "/ingredients_shield/organic_ginger_extract.png",
    "img_desc": "/ingredient_description/organic_ginger_extract.jpg",
    "derived_from": "The root of the Zingiber officinale plant.",
    "amounts": {
      "advantage": 100,
      "shield": 100
    },
    "amount_in_products": [],
    "overview": "Anti-inflammatory herb that helps nausea, weight loss, osteoarthritis, blood sugar, and heart health.",
    "form": "Extract",
    "found_in": [
      "Ginger Root"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 15123,
    "highlighted_research": [
      {
        "title": "Fresh ginger (Zingiber officinale) has anti-viral activity against human respiratory syncytial virus in human respiratory tract cell lines",
        "source": "Journal of Ethnopharmacology"
      },
      {
        "title": "Pharmacotherapeutic potential of ginger and its compounds in age-related neurological disorders",
        "source": "Pharmacology and Therapeutics"
      },
      {
        "title": "A review of the gastroprotective effects of ginger (Zingiber officinale Roscoe)",
        "source": "Food and Functions"
      },
      {
        "title": "A systematic review of the anti-obesity and weight lowering effect of ginger (Zingiber officinale Roscoe) and its mechanisms of action",
        "source": "Phytotherapy Research"
      }
    ],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9654013/",
        "t": "Contains gingerol, which has potent medicinal properties"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7019938/",
        "t": "Can treat nausea"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29393665/",
        "t": "May help with weight loss"
      },
      {
        "l": "https://www.arthritis.org/health-wellness/treatment/complementary-therapies/supplements-and-vitamins/health-benefits-of-ginger",
        "t": "Can help with osteoarthritis"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/35031435/",
        "t": "May lower blood sugar"
      }
    ],
    "main_use_case": "Immunity & Inflammation / Heart, Blood & Circulation / General Wellness"
  },
  {
    "handle": "ingredient-passion-flower",
    "name": "Passion Flower",
    "img": "/ingredients_lucid/passion-flower.jpg",
    "img_desc": "/ingredient_description/passion-flower.jpg",
    "derived_from": "The leaves, stems, and flowers of the Passiflora incarnata plant.",
    "amounts": {
      "lucid": 160
    },
    "amount_in_products": [],
    "overview": "Calming herb that may improve sleep, anxiety, digestion, and stress relief.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 7009,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7766837/",
        "t": "It may calm your mind"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3113390/",
        "t": "It might soothe your stomach"
      },
      {
        "l": "https://www.nccih.nih.gov/health/passionflower",
        "t": "Help relieve anxiety and insomnia"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / General Wellness"
  },
  {
    "handle": "ingredient-resveratrol",
    "name": "Resveratrol",
    "img": "/ingredients/resveratrol.webp",
    "img_desc": "/ingredients/resveratrol.webp",
    "derived_from": "A compound found in the skin of grapes, berries, and peanuts.",
    "amounts": {
      "btr": 1000,
      "cheat": 180
    },
    "amount_in_products": [],
    "overview": "Antioxidant compound supporting heart, brain, insulin sensitivity, and joint health.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 93338,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/27144581/",
        "t": "Resveratrol Supplements May Help Lower Blood Pressure"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3957267/",
        "t": "It Has a Positive Effect on Blood Fats"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4030174/",
        "t": "It Protects the Brain"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4160010/",
        "t": "It May Increase Insulin Sensitivity"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3344210/",
        "t": "It May Ease Joint Pain"
      }
    ],
    "main_use_case": "Immunity & Inflammation / Heart, Blood & Circulation"
  },
  {
    "handle": "ingredient-pomegranate-powder",
    "name": "Pomegranate Powder",
    "img": "/ingredients/pomegranate.webp",
    "img_desc": "/ingredients/pomegranate.webp",
    "derived_from": "The fruit of the Punica granatum plant.",
    "amounts": {
      "zeus": 200
    },
    "amount_in_products": [],
    "overview": "Anti-inflammatory fruit with heart, urinary, anticancer, and antimicrobial benefits.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 11581,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31806905/",
        "t": "May help keep inflammation at bay"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29729421/",
        "t": "May have anticancer properties"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/28608832/",
        "t": "May offer heart health benefits"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/25085198/",
        "t": "Support urinary health"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31838294/",
        "t": "May have antimicrobial properties"
      }
    ],
    "main_use_case": "Immunity & Inflammation / Heart, Blood & Circulation"
  },
  {
    "handle": "ingredient-prickly-pear-bark-extract",
    "name": "Prickly Pear Bark Extract",
    "img": "/ingredients/prickly-pear-bark.webp",
    "img_desc": "/ingredients/prickly-pear-bark.webp",
    "derived_from": "The bark of the Prickly Pear cactus.",
    "amounts": {
      "cheat": 200
    },
    "amount_in_products": [],
    "overview": "May help with pain, digestion, and antimicrobial support.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 1221,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31068805/",
        "t": "May relieve pain and inflammation"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/31331314/",
        "t": "May help treat digestive complaints"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/25448503/",
        "t": "May have antibacterial and antifungal properties"
      }
    ],
    "main_use_case": "General Wellness, Digestion & Skin"
  },
  {
    "handle": "ingredient-pygeum-extract",
    "name": "Pygeum Extract",
    "img": "/ingredients/pygeum.webp",
    "img_desc": "/ingredients/pygeum.webp",
    "derived_from": "The bark of the African cherry tree, Prunus africana.",
    "amounts": {
      "zeus": 100
    },
    "amount_in_products": [],
    "overview": "Supports prostate, kidney, and urinary health, with anti-inflammatory and anticancer potential.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 217,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://www.mdpi.com/1420-3049/26/23/7141",
        "t": "It may help treat benign prostatic hyperplasia (BPH)"
      },
      {
        "l": "https://www.mdpi.com/1420-3049/26/23/7141",
        "t": "It may help treat prostate cancer"
      },
      {
        "l": "https://www.niddk.nih.gov/health-information/urologic-diseases/prostate-problems/enlarged-prostate-benign-prostatic-hyperplasia",
        "t": "It may help treat prostatitis symptoms"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC11039028/",
        "t": "It may help reduce general inflammation"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC11039028/",
        "t": "It may help treat symptoms of kidney disease"
      }
    ],
    "main_use_case": "Hormones, Men’s & Women’s Health"
  },
  {
    "handle": "ingredient-quercetin",
    "name": "Quercetin",
    "img": "/ingredients/quercetin.webp",
    "img_desc": "/ingredients/quercetin.webp",
    "derived_from": "A plant pigment (flavonoid) found in fruits, vegetables, and grains.",
    "amounts": {
      "zeus": 100
    },
    "amount_in_products": [],
    "overview": "Plant flavonoid that reduces inflammation, allergies, blood pressure, and may lower cancer and brain disorder risk.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 102940,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/27294919/",
        "t": "May reduce inflammation"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/20548131/",
        "t": "May ease allergy symptoms"
      },
      {
        "l": "https://www.spandidos-publications.com/or/33/6/2659",
        "t": "May have anticancer effects"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/25666032/",
        "t": "May lower your risk of chronic brain disorders"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/8919657/",
        "t": "May reduce blood pressure"
      }
    ],
    "main_use_case": "Immunity & Inflammation / Heart, Blood & Circulation"
  },
  {
    "handle": "ingredient-rhodiola-rosia",
    "name": "Rhodiola Rosea Extract Salidroside",
    "img": "/ingredients_pro/rhodiola-rosia.jpg",
    "img_desc": "/ingredient_description/rhodiola-rosia.jpg",
    "derived_from": "The root of the Rhodiola rosea plant.",
    "amounts": {
      "pro": 160
    },
    "amount_in_products": [],
    "overview": "Adaptogen that reduces stress, fatigue, depression, and improves exercise and brain performance.",
    "form": "",
    "found_in": [
      "n/a"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 1400,
    "highlighted_research": [
      {
        "title": "Rhodiola rosea L.: an herb with anti-stress, anti-aging, and immunostimulating properties for cancer chemoprevention",
        "source": "National Library of Medicine"
      },
      {
        "title": "Rhodiola rosea L. and Alzheimers Disease: From Farm to Pharmacy",
        "source": "National Library of Medicine"
      },
      {
        "title": "Rhodiola rosea versus sertraline for major depressive disorder: A randomized placebo-controlled trial",
        "source": "National Library of Medicine"
      },
      {
        "title": "Stress management and the role of Rhodiola rosea: a review",
        "source": "National Library of Medicine"
      }
    ],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5370380/",
        "t": "May help decrease stress"
      },
      {
        "l": "https://karger.com/cmr/article/24/1/46/67709/Rhodiola-rosea-in-Subjects-with-Prolonged-or",
        "t": "May help with fatigue"
      },
      {
        "l": "https://www.sciencedirect.com/science/article/abs/pii/S0944711315000331",
        "t": "Could help reduce symptoms of depression"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6288277/",
        "t": "May improve brain function"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7670727/",
        "t": "May improve exercise performance"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / Energy & Exercise"
  },
  {
    "handle": "ingredient-rye-pollen-extract",
    "name": "Rye Pollen Extract",
    "img": "/ingredients/rye.webp",
    "img_desc": "/ingredients/rye.webp",
    "derived_from": "The pollen of the rye plant, Secale cereale.",
    "amounts": {
      "zeus": 100
    },
    "amount_in_products": [],
    "overview": "May reduce symptoms of prostate enlargement (BPH).",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 2607,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5401347/",
        "t": "Improve symptoms such as pain in people with mild to moderate BPH"
      }
    ],
    "main_use_case": "Hormones, Men’s & Women’s Health"
  },
  {
    "handle": "ingredient-saw-palmetto-extract-fatty-acid",
    "name": "Saw Palmetto Extract Fatty Acid",
    "img": "/ingredients/saw-palmetto-extract-fatty-acid.webp",
    "img_desc": "/ingredients/saw-palmetto-extract-fatty-acid.webp",
    "derived_from": "The berries of the Serenoa repens plant.",
    "amounts": {
      "zeus": 320
    },
    "amount_in_products": [],
    "overview": "Supports prostate, hormone, urinary, hair, and inflammation health.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 24,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7706486/",
        "t": "May prevent hair loss"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7333342/",
        "t": "May improve urinary tract function"
      },
      {
        "l": "https://journals.sagepub.com/doi/full/10.1177/1934578X211059635",
        "t": "May support prostate health"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/25683150/",
        "t": "May decrease inflammation"
      },
      {
        "l": "https://www.ahajournals.org/doi/full/10.1161/CIRCHEARTFAILURE.121.008755",
        "t": "May help regulate testosterone levels"
      }
    ],
    "main_use_case": "Hormones, Men’s & Women’s Health"
  },
  {
    "handle": "ingredient-soybean-extract-phosphatidylserine",
    "name": "Soybean Extract Phosphatidylserine",
    "img": "/ingredient_description/phosphatidyl_serine.jpg",
    "img_desc": "/ingredient_description/phosphatidyl_serine.jpg",
    "derived_from": "The cell membranes of soybeans.",
    "amounts": {
      "advantage": 50,
      "pro": 50
    },
    "amount_in_products": [],
    "overview": "Supports memory, ADHD, cortisol regulation, and athletic performance.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 3044,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://link.springer.com/article/10.2165/00007256-200636080-00003",
        "t": "May Boost Athletic Performance"
      },
      {
        "l": "https://www.jstage.jst.go.jp/article/jcbn/47/3/47_10-62/_article",
        "t": "May Improve Memory Loss"
      },
      {
        "l": "https://www.cambridge.org/core/journals/european-psychiatry/article/abs/effect-of-phosphatidylserine-containing-omega3-fattyacids-on-attentiondeficit-hyperactivity-disorder-symptoms-in-children-a-doubleblind-placebocontrolled-trial-followed-by-an-openlabel-extension/DFD6EDB0C9D0BD7BC269D18FD6E6C04E",
        "t": "May Treat ADHD Symptoms"
      },
      {
        "l": "https://ojs.uclouvain.be/index.php/EBR/article/view/9863",
        "t": "May Lower Cortisol Levels"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health"
  },
  {
    "handle": "ingredient-sulbutiamine",
    "name": "Sulbutiamine",
    "img": "/ingredients/sulbutiamine.jpg",
    "img_desc": "/ingredient_description/n-acetyl_l-tyrosine.jpg",
    "derived_from": "A synthetic derivative of thiamine (Vitamin B1).",
    "amounts": {
      "advantage": 1,
      "pro": 10
    },
    "amount_in_products": [],
    "overview": "",
    "form": "Synthetic Derivative of Thiamine",
    "found_in": [
      "n/a"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 93,
    "highlighted_research": [
      {
        "title": "Chronic treatment with sulbutiamine improves memory in an object recognition task and reduces some amnesic effects of dizocilpine in a spatial delayed-non-match-to-sample task",
        "source": "Progress in Neuro-Psychopharmacology and Biological Psychology"
      },
      {
        "title": "Effects of sulbutiamine (Arcalion 200) on psycho-behavioral inhibition in major depressive episodes",
        "source": "L Encephale"
      },
      {
        "title": "Sulbutiamine in sports",
        "source": "Drug Testing and Analysis"
      },
      {
        "title": "Pharmacologic and therapeutic features of sulbutiamine",
        "source": "Drugs of Today"
      }
    ],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/10858919/",
        "t": "Mood"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/28755683/",
        "t": "Weakness and Fatigue"
      },
      {
        "l": "https://www.sciencedirect.com/science/article/abs/pii/S0278584605001661",
        "t": "Memory"
      }
    ],
    "main_use_case": "Energy, Exercise & Recovery"
  },
  {
    "handle": "ingredient-taurine",
    "name": "Taurine",
    "img": "/ingredients/sulbutiamine.jpg",
    "img_desc": "/ingredient_description/n-acetyl_l-tyrosine.jpg",
    "derived_from": "A naturally occurring amino sulfonic acid.",
    "amounts": {
      "advantage": 1508,
      "shield": 379,
      "pro": 568,
      "sprint": 1253.1,
      "zeus": 492.9
    },
    "amount_in_products": [],
    "overview": "Supports heart, blood sugar, exercise, eye, and hearing health.",
    "form": "Synthetic Taurine",
    "found_in": [
      "n/a"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 52405,
    "highlighted_research": [
      {
        "title": "Taurine Regulation of Neuroendocrine Function",
        "source": "Advances in Experimental Medicine and Biology"
      },
      {
        "title": "The Effects of an Oral Taurine Dose and Supplementation Period on Endurance Exercise Performance in Humans: A Meta-Analysis",
        "source": "Sports Medicine"
      },
      {
        "title": "Dietary Taurine Supplementation in School Meals Has Positive Effect on School Attitude Assessment in Korean High School Students",
        "source": "Advances in Experimental Medicine and Biology"
      },
      {
        "title": "Taurine and its analogs in neurological disorders: Focus on therapeutic potential and molecular mechanisms",
        "source": "Redox Biology"
      }
    ],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29492671/",
        "t": "May fight diabetes"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7551180/",
        "t": "May improve heart health"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8152067/",
        "t": "May boost exercise performance"
      },
      {
        "l": "",
        "t": "May benefit eye health"
      },
      {
        "l": "",
        "t": "May benefit hearing"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Energy & Exercise"
  },
  {
    "handle": "ingredient-valerian",
    "name": "Valerian",
    "img": "/ingredients_lucid/valerian.jpg",
    "img_desc": "/ingredient_description/valerian.jpg",
    "derived_from": "The roots of the Valeriana officinalis plant.",
    "amounts": {
      "lucid": 200
    },
    "amount_in_products": [],
    "overview": "Natural sleep aid that supports stress, menopause, menstrual health, and restless leg syndrome.",
    "form": "Synthetic",
    "found_in": [
      "Valeriana officinalis"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 5186,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8077445/",
        "t": "Valerian root for anxiety symptoms and stress"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7585905/",
        "t": "Valerian root may help you sleep better"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/24250592/",
        "t": "Menopausal symptoms"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/27419099/",
        "t": "Menstrual issues"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/19284179/",
        "t": "Restless legs syndrome"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / Hormones, Men’s & Women’s Health / Energy & Exercise"
  },
  {
    "handle": "ingredient-vitamin-b12",
    "name": "Vitamin B12",
    "img": "/ingredients/vitamin-b12.webp",
    "img_desc": "/ingredients/vitamin-b12.webp",
    "derived_from": "Bacteria and archaea.",
    "amounts": {
      "bta": 0.0024,
      "btr": 0.0024,
      "btg": 0.0024,
      "sprint": 1
    },
    "amount_in_products": [],
    "overview": "Essential for red blood cells, pregnancy, bone, eye, and brain health.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 90870,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://www.ncbi.nlm.nih.gov/books/NBK441923/",
        "t": "Helps with red blood cell formation and anemia prevention"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4161975/",
        "t": "May prevent major birth issues"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/34116377/",
        "t": "May support bone health and prevent osteoporosis"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9318446/",
        "t": "May reduce your risk of macular degeneration"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6770181/",
        "t": "May improve mood and symptoms of depression"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Hormones, Men’s & Women’s Health"
  },
  {
    "handle": "ingredient-vitamin-b3-niacin",
    "name": "Vitamin B3 (Niacin)",
    "img": "/ingredients/vitamin-b3-niacin.webp",
    "img_desc": "/ingredients/vitamin-b3-niacin.webp",
    "derived_from": "A form of vitamin B3, which is a key nutrient found in many foods.",
    "amounts": {
      "sprint": 35
    },
    "amount_in_products": [],
    "overview": "Supports cholesterol, blood pressure, brain, and skin health.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 5210,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/27793642/",
        "t": "Improves blood fat levels"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/33404619/",
        "t": "May reduce blood pressure"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/23312803/",
        "t": "Boosts brain function"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/26488693/",
        "t": "Improves skin health"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation"
  },
  {
    "handle": "ingredient-vitamin-b5",
    "name": "Vitamin B5 (Pantothenic Acid)",
    "img": "/ingredients/vitamin_b5.jpg",
    "img_desc": "/ingredient_description/vitamin_b5.jpg",
    "derived_from": "A form of vitamin B5, found in a wide variety of foods.",
    "amounts": {
      "advantage": 30,
      "pro": 30,
      "sprint": 30
    },
    "amount_in_products": [],
    "overview": "Essential for skin, hair, nerves, digestion, blood, and hormone production.",
    "form": "Pantothenic Acid",
    "found_in": [
      "Nuts, Seeds, Avocado"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 17124,
    "highlighted_research": [
      {
        "title": "Pantothenic acid and pantothenol increase biosynthesis of glutathione by boosting cell energetics",
        "source": "FEBS Letters"
      },
      {
        "title": "Vitamins and Minerals for Energy, Fatigue and Cognition: A Narrative Review of the Biochemical and Clinical Evidence",
        "source": "Nutrients"
      },
      {
        "title": "Cerebral deficiency of vitamin B5 (d-pantothenic acid; pantothenate) as a potentially-reversible cause of neurodegeneration and dementia in sporadic Alzheimers disease",
        "source": "Biochemical and Biophysical Research Communications"
      },
      {
        "title": "Effects of ethanol and pantothenic acid on brain acetylcholine synthesis",
        "source": "British Journal of Pharmacology"
      }
    ],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3942300/",
        "t": "Healthy skin, hair, and eyes"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3942300/",
        "t": "Proper functioning of the nervous system and liver"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3942300/",
        "t": "Healthy digestive tract"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3942300/",
        "t": "Making red blood cells, which carry oxygen throughout the body"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3942300/",
        "t": "Making sex and stress-related hormones in the adrenal glands"
      }
    ],
    "main_use_case": "General Wellness, Digestion & Skin"
  },
  {
    "handle": "ingredient-vitamin-b6",
    "name": "Vitamin B6",
    "img": "/ingredients_shield/vitamin_b6.png",
    "img_desc": "/ingredient_description/vitamin_b6.jpg",
    "derived_from": "A group of compounds, including pyridoxine, found in many foods.",
    "amounts": {
      "advantage": 2,
      "shield": 2,
      "pro": 10,
      "bta": 1,
      "btr": 1,
      "btg": 1,
      "sprint": 25
    },
    "amount_in_products": [],
    "overview": "Important for mood, brain health, anemia prevention, PMS, and pregnancy nausea.",
    "form": "Pyridoxine HCI",
    "found_in": [
      "Oats, Wheatgerm, Bananas"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 45357,
    "highlighted_research": [
      {
        "title": "Homocysteine, B Vitamins, and Cognitive Impairment",
        "source": "Annual Review of Nutrition"
      },
      {
        "title": "Low serum concentrations of vitamin B6 and iron are related to panic attack and hyperventilation attack",
        "source": "Acta Medica Okayama"
      },
      {
        "title": "Superiority of magnesium and vitamin B6 over magnesium alone on severe stress in healthy adults with low magnesemia: A randomized, single-blind clinical trial",
        "source": "PLoS One"
      },
      {
        "title": "Vitamin B6 level is associated with symptoms of depression",
        "source": "Psychotherapy and Psychosomatics"
      }
    ],
    "benefits": [
      {
        "l": "https://lpi.oregonstate.edu/mic/vitamins/vitamin-B6",
        "t": "May Improve Mood and Reduce Symptoms of Depression"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/14584010/",
        "t": "May Promote Brain Health and Reduce Alzheimer’s Risk"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/17260529/",
        "t": "May Prevent and Treat Anemia by Aiding Hemoglobin Production"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/2558186/",
        "t": "May Be Useful in Treating Symptoms of PMS"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/24574047/",
        "t": "May Help Treat Nausea During Pregnancy"
      }
    ],
    "main_use_case": "Brain, Mood & Cognitive Health / Hormones, Men’s & Women’s Health"
  },
  {
    "handle": "ingredient-vitamin-c",
    "name": "Vitamin C (Ascorbic Acid)",
    "img": "/ingredients_shield/vitamin_c.png",
    "img_desc": "/ingredient_description/vitamin_c.jpg",
    "derived_from": "A form of vitamin C, found in citrus fruits and vegetables.",
    "amounts": {
      "shield": 966,
      "pro": 100,
      "bta": 301,
      "btr": 301,
      "btg": 721
    },
    "amount_in_products": [],
    "overview": "Antioxidant that supports immunity, blood pressure, heart health, uric acid, and iron absorption.",
    "form": "Ascorbic Acid",
    "found_in": [
      "Oranges, Broccoli, Peppers"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 165408,
    "highlighted_research": [
      {
        "title": "Vitamin C and Immune Function",
        "source": "Medizinische Monatsschrift fur Pharmazeuten"
      },
      {
        "title": "Deficiency of Vitamin D and vitamin C in the pathogenesis of bronchial asthma",
        "source": "Bratislavske Lekarske Listy"
      },
      {
        "title": "Vitamin C and its physiological role with respect to the components of the immune system",
        "source": "Vnitrni Lekarstvi"
      },
      {
        "title": "Vitamin C Pretreatment Enhances the Antibacterial Effect of Cold Atmospheric Plasma",
        "source": "Frontiers in Cellular and Infection Microbiology"
      }
    ],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC11820684/",
        "t": "May reduce your risk of chronic disease"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3325833/",
        "t": "May help manage high blood pressure"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/15585762/",
        "t": "May lower your risk of heart disease"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC2853937/",
        "t": "May reduce blood uric acid levels and help prevent gout attacks"
      },
      {
        "l": "https://www.ncbi.nlm.nih.gov/books/NBK448204/",
        "t": "Helps prevent iron deficiency"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Immunity & Inflammation"
  },
  {
    "handle": "ingredient-vitamin-d",
    "name": "Vitamin D",
    "img": "/ingredients_shield/vitamin_d.png",
    "img_desc": "/ingredient_description/vitamin_d3.jpg",
    "derived_from": "Sunlight, or certain foods like fatty fish.",
    "amounts": {
      "bta": 0.1,
      "btr": 0.1,
      "btg": 0.1,
      "zeus": 0.1
    },
    "amount_in_products": [],
    "overview": "Essential for immune, mood, and metabolic health, and may support weight management.",
    "form": "Cholecalciferol",
    "found_in": [
      "Lichen"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 190706,
    "highlighted_research": [
      {
        "title": "Vitamin-D in the Immune System: Genomic and Non-Genomic Actions",
        "source": "Mini Reviews in Medicinal Chemistry"
      },
      {
        "title": "Vitamin D modulation of innate immune responses to respiratory viral infections",
        "source": "Reviews in Medical Biology"
      },
      {
        "title": "Modulation of inflammatory and immune responses by vitamin D",
        "source": "Journal of Auto-Immunity"
      },
      {
        "title": "Vitamin A and vitamin D regulate the microbial complexity, barrier function, and the mucosal immune responses to ensure intestinal homeostasis",
        "source": "Critical Reviews in Biochemistry and Molecular Biology"
      }
    ],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29243029/",
        "t": "Vitamin D may fight disease"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/32365423/",
        "t": "May regulate mood and reduce depression"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/33792853/",
        "t": "May support weight loss"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Immunity & Inflammation"
  },
  {
    "handle": "ingredient-vitamin-d3",
    "name": "Vitamin D3",
    "img": "/ingredients/vitamin-d3.webp",
    "img_desc": "/ingredients/vitamin-d3.webp",
    "derived_from": "The skin of animals, including humans, when exposed to sunlight.",
    "amounts": {
      "shield": 0.1,
      "lucid": 0.1,
      "pro": 0.01,
      "sprint": 0.1
    },
    "amount_in_products": [],
    "overview": "",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 80909,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29243029/",
        "t": "Vitamin D may fight disease"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/32365423/",
        "t": "May regulate mood and reduce depression"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/33792853/",
        "t": "May support weight loss"
      }
    ],
    "main_use_case": "Immunity & Inflammation"
  },
  {
    "handle": "ingredient-vitamin-e",
    "name": "Vitamin E",
    "img": "/ingredients_shield/vitamin_e.png",
    "img_desc": "/ingredient_description/vitamin_e.jpg",
    "derived_from": "Found in vegetable oils, nuts, and leafy greens.",
    "amounts": {
      "shield": 15
    },
    "amount_in_products": [],
    "overview": "Antioxidant that supports heart, liver, menstrual, and skin health.",
    "form": "Alpha-tocopherol",
    "found_in": [
      "Avocado, Sunflower Seeds, Spinach, Almonds"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 109725,
    "highlighted_research": [
      {
        "title": "Is vitamin E an anti-allergic compound?",
        "source": "Journal of Biological Regulators and Homeostatic Agents"
      },
      {
        "title": "The Role of Vitamin E in Immunity",
        "source": "Nutrients"
      },
      {
        "title": "Vitamin E and immune response in the aged: molecular mechanisms and clinical implications",
        "source": "Immunilogical Reviews"
      },
      {
        "title": "Vitamin E status and immune function",
        "source": "Methods in Enzymology"
      },
      {
        "title": "The role of vitamin E in immune response and disease resistance",
        "source": "Annals of The New York Academy of Sciences"
      }
    ],
    "benefits": [
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29891745/",
        "t": "Vitamin E may reduce markers of oxidative stress and improve antioxidant defenses"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/30846828/",
        "t": "Vitamin E may reduce heart disease risk factors"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/32810309/",
        "t": "Vitamin E may benefit those with nonalcoholic fatty liver disease (NAFLD)"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/29542390/",
        "t": "Vitamin E may help manage menstrual pain"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/34655146/",
        "t": "May benefit skin health"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / General Wellness"
  },
  {
    "handle": "ingredient-white-kidney-bean-extract",
    "name": "White Kidney Bean Extract",
    "img": "/ingredients/l-tyrosine.webp",
    "img_desc": "/ingredients/l-tyrosine.webp",
    "derived_from": "The beans of the Phaseolus vulgaris plant.",
    "amounts": {
      "cheat": 363.8
    },
    "amount_in_products": [],
    "overview": "Protein- and fiber-rich legume that supports weight management and overall nutrition.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 16479,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5790854/",
        "t": "Loaded with protein"
      },
      {
        "l": "https://nap.nationalacademies.org/catalog/10490/dietary-reference-intakes-for-energy-carbohydrate-fiber-fat-fatty-acids-cholesterol-protein-and-amino-acids",
        "t": "Provide ample fiber"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4608274/",
        "t": "May promote a healthy body weight"
      }
    ],
    "main_use_case": "General Wellness, Digestion & Skin"
  },
  {
    "handle": "ingredient-zinc",
    "name": "Zinc",
    "img": "/ingredients_shield/zinc.png",
    "img_desc": "/ingredient_description/zinc.jpg",
    "derived_from": "The mineral zinc.",
    "amounts": {
      "shield": 9,
      "lucid": 7.2,
      "sprint": 10
    },
    "amount_in_products": [],
    "overview": "Supports immunity, skin, wound healing, inflammation, and age-related disease prevention.",
    "form": "Zinc Gluconate",
    "found_in": [
      "Beans, Nuts, Wholegrains"
    ],
    "manufactured_in": "Europe",
    "number_of_studies": 538609,
    "highlighted_research": [
      {
        "title": "Zinc as a Gatekeeper of Immune Function",
        "source": "Nutrients"
      },
      {
        "title": "Zinc Status and Autoimmunity: A Systematic Review and Meta-Analysis",
        "source": "Nutrients"
      },
      {
        "title": "The Role of Zinc in Antiviral Immunity",
        "source": "Advances in Nutrition"
      },
      {
        "title": "The Role of Zinc and Zinc Homeostasis in Macrophage Function",
        "source": "Journal of Immunology Research"
      }
    ],
    "benefits": [
      {
        "l": "https://www.ncbi.nlm.nih.gov/books/NBK493231/",
        "t": "Boosts your immune system"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5793244/",
        "t": "Accelerates wound healing"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/32411807/",
        "t": "May reduce the risk of certain age-related diseases"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/25597339/",
        "t": "May help treat acne"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/32828910/",
        "t": "Decreases inflammation"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Immunity & Inflammation / General Wellness"
  },
  {
    "handle": "ingredient-zinc-as-zinc-oxide",
    "name": "Zinc (as Zinc Oxide)",
    "img": "/ingredient_description/zinc.jpg",
    "img_desc": "/ingredient_description/zinc.jpg",
    "derived_from": "The mineral zinc and oxygen.",
    "amounts": {
      "zeus": 10
    },
    "amount_in_products": [],
    "overview": "Supports immunity, skin, wound healing, inflammation, and age-related disease prevention.",
    "form": "Synthetic",
    "found_in": [],
    "manufactured_in": "Europe",
    "number_of_studies": 150249,
    "highlighted_research": [],
    "benefits": [
      {
        "l": "https://www.ncbi.nlm.nih.gov/books/NBK493231/",
        "t": "Boosts your immune system"
      },
      {
        "l": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5793244/",
        "t": "Accelerates wound healing"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/32411807/",
        "t": "May reduce the risk of certain age-related diseases"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/25597339/",
        "t": "May help treat acne"
      },
      {
        "l": "https://pubmed.ncbi.nlm.nih.gov/32828910/",
        "t": "Decreases inflammation"
      }
    ],
    "main_use_case": "Heart, Blood & Circulation / Immunity & Inflammation / General Wellness"
  }
];
Object.entries(effic_ing_products).forEach(p_ent => {
  let p_key = p_ent[0]
  let p_value = p_ent[1]
  //console.log('effic product: ', effic_ing_products[p_key])
  if(typeof product_colours[p_value.href] !== undefined) {
    effic_ing_products[p_key]['colour'] = product_colours[p_value.href]['c']
    if(product_colours[p_value.href]['i'] !== '') {
      effic_ing_products[p_key]['src'] = product_colours[p_value.href]['i']
    }
  }
})

effic_all_ingredients = effic_all_ingredients.map(ing => {
  let max_href = ''
  let max_amount = 0
  ing.amount_in_products = Object.entries(ing.amounts).map(p_entries => {
    let p_id = p_entries[0]
    let p_amount = p_entries[1]
    if(p_amount > max_amount) {
      max_amount = p_amount
      max_href = effic_ing_products[p_id].href
    }
    return {
      ...effic_ing_products[p_id],
      amount: p_amount
    }
  })
  if(max_href) {
    ing.cta = max_href
  }
  return ing
})